import { Typography, TypographyProps } from '@mui/material';

const FieldHeading = (props: TypographyProps) => (
  <Typography variant='h5' component='h2' mb={2} {...props} />
);

export default FieldHeading;
